import { z } from 'zod';

export const ParallelableCapacity = {
    validator: z.number().min(1).optional().default(1),
};
